import { areAllSelectedDivisionsAnnualPowerOnly } from '../../../../../utils/events';

export function getHybridGateTitleText({ event, selectedDivisionIds }) {
    return areAllSelectedDivisionsAnnualPowerOnly(event, selectedDivisionIds)
        ? 'The division you selected requires an annual Power membership'
        : 'One of the divisions you selected requires an annual Power membership';
}
